import SessaoAuth from "../../Hooks/SessaoAuth";
import { useNavigate } from "react-router-dom";

export const usePermiteAcesso = (modulo) => {
    const { sessao } = SessaoAuth();
    const navigate = useNavigate();

    const temAcesso = sessao?.modulos?.some((m) => Number(m) === Number(modulo));

    if (!temAcesso) {
        navigate("/error");
    }
}

export const formatDate = (dateString) => {

    if (dateString == null || dateString === "") return "";

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    if (dateString instanceof Date) {
        return formatter.format(dateString);
    }

    // 3a) dd/MM/yyyy [HH:mm[:ss]]
    const mBR = dateString.match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/ // opcional hora
    );

    if (mBR) {
        const [data, hora = "00:00:00"] = dateString.trim().split(" ");
        const [dd, mm, yyyy] = data.split("/");

        const date = new Date(`${yyyy}-${mm}-${dd} ${hora}`);
        return formatter.format(date);
    } else {
        const date = new Date(dateString);
        return formatter.format(date);
    }

};

export const formatDateAbre = (dateString) => {


    if (dateString == null || dateString === "") return "";

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
    });

    if (dateString instanceof Date) {
        return formatter.format(dateString);
    }

    // 3a) dd/MM/yyyy [HH:mm[:ss]]
    const mBR = dateString.match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/ // opcional hora
    );

    if (mBR) {
        const [data, hora = "00:00:00"] = dateString.trim().split(" ");
        const [dd, mm, yyyy] = data.split("/");

        const date = new Date(`${yyyy}-${mm}-${dd} ${hora}`);

        return formatter.format(date);
    } else {
        try {
            const date = new Date(dateString);
            const formatado = formatter.format(date);
            return formatado;
        } catch (erro) {
            return "";
        }
    }
}

export function formatDateTime(dateString) {

    if (dateString instanceof Date) {
        const formatterDate = new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        const formatterTime = new Intl.DateTimeFormat('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false, // Formato 24 horas
        });
        return `${formatterDate.format(dateString)} ${formatterTime.format(dateString)}`;
    }

    if (dateString == null || dateString === "") return "";

    const [data, hora = "00:00:00"] = dateString.trim().split(" ");
    const [dd, mm, yyyy] = data.split("/");

    const date = new Date(`${yyyy}-${mm}-${dd} ${hora}`);

    // Formata data para dd/MM/yyyy
    const formattedDate = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);

    // Formata hora para HH:mm:ss
    const formattedTime = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Formato 24 horas
    }).format(date);

    return `${formattedDate} ${formattedTime}`;
}

export function formatTime(dateString) {

    if (dateString == null || dateString === "") return "";

    const [data, hora = "00:00:00"] = dateString.trim().split(" ");
    const [dd, mm, yyyy] = data.split("/");

    const date = new Date(`${yyyy}-${mm}-${dd} ${hora}`);

    // Formata hora para HH:mm:ss
    const formattedTime = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Formato 24 horas
    }).format(date);

    return `${formattedTime}`;
}

export function formatTimeHM(dateString) {

    if (dateString == null || dateString === "") return "";

    const [data, hora = "00:00:00"] = dateString.trim().split(" ");
    const [dd, mm, yyyy] = data.split("/");

    const date = new Date(`${yyyy}-${mm}-${dd} ${hora}`);

    // Formata hora para HH:mm:ss
    const formattedTime = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Formato 24 horas
    }).format(date);

    return `${formattedTime}`;
}

export function formatTimeDecimal(inputDate) {

    const date = new Date(inputDate);
    return date.getHours() + date.getMinutes() / 60;
}


export const formatDoisDigitos = (number) => {
    return number.toString().padStart(2, '0');
};

export const validarCPF = (cpf) => {

    if (!cpf) return false; // evita null/undefined
    cpf = String(cpf).replace(/[^\d]+/g, ""); // força string e remove não-numéricos
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0, resto;

    // Validação do 1º dígito
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    // Validação do 2º dígito
    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return true;
}

//Validação de CNPJ
export const validarCnpj = (cnpj) => {
    if (!cnpj) return false;

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    const calcularDigito = (cnpj, posicoes) => {
        let soma = 0;

        for (let i = 0; i < posicoes.length; i++) {
            soma += parseInt(cnpj[i]) * posicoes[i];
        }

        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const primeiroDigito = calcularDigito(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    if (primeiroDigito !== parseInt(cnpj[12])) return false;

    const segundoDigito = calcularDigito(cnpj, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    if (segundoDigito !== parseInt(cnpj[13])) return false;

    return true;
};


export const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

export const validarSenha = (senha) => {
    const regex = /^(?=\S{8,64}$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$_\-.!?+=*&()])[A-Za-z\d@#$_\-.!?+=*&()]+$/;
    return regex.test(senha);
}

export function tokenExpirado(valToken) {
  if (!valToken) return true; // se não tiver token → expirado

  const [data, hora] = valToken.split(" ");
  const [dia, mes, ano] = data.split("/");
  const [hh, mm, ss] = hora.split(":");

  const tokenDate = new Date(ano, mes - 1, dia, hh, mm, ss);
  const agora = new Date();

  return agora > tokenDate; // TRUE = token expirou
}